/* ScalperIntel — refund guarantee badge (Phase 3).
   Listens for Dawn's variant-change signal (a `change` event on the hidden
   <input name="id"> inside the product form, fired by VariantSelects/Radios
   after it updates the current variant). Looks up the new variant's
   refund_title and refund_body in the data island the snippet embedded,
   and swaps the badge text + visibility with a 150ms opacity fade.

   Visibility rule: show only when BOTH title and body are non-empty.
   Otherwise hide the entire pill. */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Convert plain text with embedded newlines into safe HTML with <br> for
  // each line break. We escape HTML special chars first because the metafield
  // is plain text and the merchant should not be able to inject markup.
  function plainToBrHtml(s) {
    if (s == null) return '';
    var div = document.createElement('div');
    div.textContent = String(s);
    var escaped = div.innerHTML; // browser escapes &, <, >, ", '
    return escaped.replace(/\r\n|\r|\n/g, '<br>');
  }

  function initBadge(root) {
    var dataEl = root.querySelector('script[type="application/json"][data-si-refund-data]');
    var titleEl = root.querySelector('[data-si-refund-title]');
    var bodyEl  = root.querySelector('[data-si-refund-body]');
    if (!dataEl || !titleEl || !bodyEl) return;

    var map = {};
    try {
      map = JSON.parse(dataEl.textContent) || {};
    } catch (e) {
      // Malformed JSON — bail. Liquid-rendered initial state still shows.
      return;
    }

    var sectionId = root.getAttribute('data-section-id');
    var formIds = [
      'product-form-' + sectionId,
      'product-form-installment-' + sectionId
    ];

    function update(variantId) {
      var key = String(variantId);
      var entry = Object.prototype.hasOwnProperty.call(map, key) ? map[key] : null;
      var title = entry && entry.title ? String(entry.title).trim() : '';
      var body  = entry && entry.body  ? String(entry.body).trim()  : '';

      // Fade out → swap → fade in.
      root.classList.add('is-updating');
      window.setTimeout(function () {
        if (title && body) {
          titleEl.textContent = title;
          bodyEl.innerHTML = plainToBrHtml(body);
          root.classList.remove('si-refund-badge--hidden');
        } else {
          // Both required to show. Hide entirely if either missing.
          root.classList.add('si-refund-badge--hidden');
          titleEl.textContent = '';
          bodyEl.textContent = '';
        }
        root.classList.remove('is-updating');
      }, 150);
    }

    function onInputChange(e) {
      var input = e.target;
      if (!input || input.name !== 'id') return;
      var id = parseInt(input.value, 10);
      if (!id) return;
      update(id);
    }

    formIds.forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      form.addEventListener('change', onInputChange);
    });
  }

  ready(function () {
    document.querySelectorAll('[data-si-refund-badge]').forEach(initBadge);
  });
})();
